import axios from "../utils/axios";
export const WebService = {
  sendMessage: async (formData) => {
    try {
      const response = await axios.post("/api/message", formData, {
        headers: {
          "Content-Type": "multipart/form-data",
        },
      });
      if (response) {
        return true;
      }
    } catch (error) {
      throw new Error("Failed to send message");
    }
  },
  getMessage: async (id, page, limit) => {
    try {
      const response = await axios.get(
        `/api/message/${id}/messages?page=${page}&limit=${limit}`
      );
      if (response?.data?.success) {
        return response.data.data;
      }
    } catch (error) {
      throw new Error(
        error?.response?.data?.message || "Failed to get message"
      );
    }
  },
  getMessageFile: async (msgId) => {
    try {
      const response = await axios.get(`/api/message/${msgId}/attachment`);
      if (response?.data?.success) {
        return response?.data?.data;
      }
    } catch (error) {
      throw new Error(
        error?.response?.data?.message || "Failed to get message file"
      );
    }
  },
  getNotification: async (page, limit,date,type) => {
    try {
      const response = await axios.get(
        `/api/notification?page=${page}&limit=${limit}&date=${date}&type=${type}`
      );
      if (response?.data?.success) {
        return response.data.data;
      }
    } catch (error) {
      throw new Error(
        error?.response?.data?.message || "Failed to get notification"
      );
    }
  },
  getNotifyCount: async () => {
    try {
      const response = await axios.get("/api/notification/count");
      if (response?.data?.success) {
        return response.data.data;
      }
    } catch (error) {
      throw new Error(
        error?.response?.data?.message || "Failed to get notification count"
      );
    }
  },
  markNotificationAsRead: async (id) => {
    try {
      const response = await axios.patch(`/api/notification/${id}`);
      if (response?.data?.success) {
        return true;
      }
    } catch (error) {
      throw new Error(
        error?.response?.data?.message || "Failed to mark notification as read"
      );
    }
  },
  markAllNotificationAsRead: async () => {
    try {
      const response = await axios.patch(`/api/notification/`);
      if (response?.data?.success) {
        return true;
      }
    } catch (error) {
      throw new Error(
        error?.response?.data?.message ||
          "Failed to mark all notification as read"
      );
    }
  },
  deleteNotification: async (id) => {
    try {
        const response = await axios.delete(`/api/notification/${id}`);
        if (response?.data?.success) {
            return true;
        }
    } catch (error) {
        throw new Error(error?.response?.data?.message || "Failed to delete notification");
    }
  },
};
